<template>
    <div class="copyright">
      <small><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022008840号</a>&nbsp;</small>
      <small> Copyright © 2019-{{copyright_year}} imgzo.cn  All Rights Reserved.</small>
    </div>
</template>
<script>
export default {
  name: "imgzoCopyright",
  data() {
    return {
      copyright_year:2019,
    };  
  },
  mounted() {
    let nowDate = new Date();
    this.copyright_year = nowDate.getFullYear(); //获取完整的年份(4位,1970-)
  },
  methods: {
  },
};
</script>
<style>
.copyright {
  position: absolute;
    bottom: 0px;
    width: 100%;
    /* height: var(--imgzoCopyright); */
    color: var(--SecondColor-9);
    text-align: center;
    /* font-size: 90%; */
    /* line-height: 120%; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}
.copyright a {
    text-decoration:none;
    color: var(--SecondColor-9);
}
</style>